import styled from 'styled-components';

export const Wrapper = styled.div`
  > div > div {
    margin-bottom: 1.5rem;
  }
`;
